module.exports = __webpack_public_path__ + "static/img/zhang.ef86f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhang.png
// module id = 5wQx
// module chunks = 2